import chalk from 'chalk';
import { getRuleById } from '../../rules/index.js';

export async function explainCommand(ruleId: string): Promise<void> {
  const rule = getRuleById(ruleId);

  if (!rule) {
    console.error(chalk.red(`Rule not found: ${ruleId}`));
    console.log(chalk.dim('\nRun `vg rules` to see all available rules.'));
    process.exit(1);
  }

  console.log('\n' + chalk.bold.cyan(`Rule: ${rule.id}`));
  console.log(chalk.dim('─'.repeat(50)));

  console.log(`\n${chalk.bold('Name:')} ${rule.name}`);
  console.log(`${chalk.bold('Category:')} ${rule.category}`);

  const severityColor =
    rule.severity === 'error' ? chalk.red : rule.severity === 'warn' ? chalk.yellow : chalk.blue;
  console.log(`${chalk.bold('Severity:')} ${severityColor(rule.severity)}`);

  console.log(`${chalk.bold('Blocking:')} ${rule.blocking ? chalk.red('Yes') : chalk.green('No')}`);
  console.log(`${chalk.bold('Autofix:')} ${rule.autofix ? chalk.green('Yes') : chalk.dim('No')}`);
  console.log(`${chalk.bold('Tool:')} ${rule.tool}`);

  console.log(`\n${chalk.bold('Description:')}`);
  console.log(`  ${rule.description}`);

  console.log(`\n${chalk.bold('Why this matters:')}`);
  console.log(`  ${rule.rationale}`);

  console.log(`\n${chalk.bold('How to fix:')}`);
  console.log(`  ${rule.fix}`);

  if (rule.examples) {
    console.log(`\n${chalk.bold('Examples:')}`);
    if (rule.examples.bad) {
      console.log(`\n  ${chalk.red('✖ Bad:')}`);
      console.log(chalk.dim('  ```'));
      console.log(`  ${rule.examples.bad.split('\n').join('\n  ')}`);
      console.log(chalk.dim('  ```'));
    }
    if (rule.examples.good) {
      console.log(`\n  ${chalk.green('✓ Good:')}`);
      console.log(chalk.dim('  ```'));
      console.log(`  ${rule.examples.good.split('\n').join('\n  ')}`);
      console.log(chalk.dim('  ```'));
    }
  }

  console.log(`\n${chalk.bold('Active in levels:')}`);
  const levels = [];
  if (rule.levels.basic) levels.push(chalk.green('basic'));
  if (rule.levels.standard) levels.push(chalk.yellow('standard'));
  if (rule.levels.strict) levels.push(chalk.red('strict'));
  console.log(`  ${levels.join(', ')}`);

  console.log(`\n${chalk.dim(`Docs: ${rule.docs}`)}\n`);
}
